import { Type } from "class-transformer";
import ResponseEntity, { InputEntity } from "../..";
import { IsInt, ValidateNested, IsBoolean } from "class-validator";
import PrivateUser from "../../user";
import OutputLc from "../../lc";

export default class TransmedValidator extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsBoolean() public readonly allow_edit!: boolean;

  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly user!: PrivateUser;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc;
}

export class TransmedValidatorInput extends InputEntity {
  constructor(public readonly public_id: string) {
    super();
  }
}

export class TransmedValidatorUpdateInput extends InputEntity {
  public constructor(public allow_edit: boolean) {
    super();
  }
}
